// @flow
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { getNormalizeAdsSelector } from '../../../selectors';
import { setOrIncrementAdVisitCounter } from '../../../actions';
import ListAdsComponent from '.';

type MapDispatchToProps = {
  onAdClick: Function,
};

type MapStateToProps = {
  normalizeAds: Array<Object>,
};

function mapDispatchToProps(dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    onAdClick(ad) {
      dispatch(setOrIncrementAdVisitCounter(ad.id));
    },
  };
}

function mapStateToProps(state: Object): MapStateToProps {
  return {
    normalizeAds: getNormalizeAdsSelector(state),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListAdsComponent);



// WEBPACK FOOTER //
// ./app/Serp/components/Lists/ListAds/container.js